import { render } from "./SelectNationality.vue?vue&type=template&id=9a075114&ts=true"
import script from "./SelectNationality.vue?vue&type=script&lang=ts"
export * from "./SelectNationality.vue?vue&type=script&lang=ts"

import "./SelectNationality.vue?vue&type=style&index=0&id=9a075114&lang=scss"

import exportComponent from "/home/uatcomp/public_html/wizards/travel-insurance-wizard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__